import { createStore, combineReducers } from 'redux';

import displayInitialState from './Reducers/DisplayInitialState';
import DisplayReducer from './Reducers/DisplayReducer';
import globalInitialState from './Reducers/GlobalInitialState';
import GlobalReducer from './Reducers/GlobalReducer';
import userInitialState from './Reducers/UserInitialState';
import UserReducer from './Reducers/UserReducer';
import { loadState, saveState, throttle } from './persistState';

const rootReducer = combineReducers({
    global: GlobalReducer,
    display: DisplayReducer,
    user: UserReducer,
});

const persistedState = loadState();

const initialState = {
    global: { ...globalInitialState, ...persistedState?.global },
    display: { ...displayInitialState, ...persistedState?.display },
    user: { ...userInitialState, ...persistedState?.user },
};

const store = createStore(rootReducer, initialState);

store.subscribe(
    throttle(() => {
        saveState(store.getState());
    }, 500)
);

export type IRootState = ReturnType<typeof rootReducer>;

export default store;
